import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getEnrolledPractitioners } from 'api/Prescribe';

export const useGetPractitionersEnrolled = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(
    ['enrolled-practitioners', ...dependencies],
    () => getEnrolledPractitioners(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...options
    }
  );
};
